<template>
	<section class="commented">
		<div class="commented__top">
			<p class="commented__status">
				등록 : {{ total }}건 / 활성 : {{ active }}건 / 비활성 :
				{{ inactive }}건
			</p>
			<div class="commented__controls">
				<button
					class="btn-excel commented__excel-download"
					type="button"
					@click="getExcelFile"
				>
					엑셀 다운로드
				</button>
				<select-box-v2
					v-model="limit"
					:options="limitOption"
					@input="getComments"
					class="commented__select-box"
				/>
			</div>
		</div>
		<div class="commented__contents">
			<div
				v-for="comment in comments"
				:key="comment.idPouchComment"
				class="commented__contents__comment comment"
			>
				<img
					:src="comment.profileImage"
					:alt="`${comment.nickName}의 프로필 이미지`"
					class="comment__image"
				/>
				<div class="comment__text">
					<p>
						<router-link
							class="comment__text__name"
							:to="`/register/register-info/${comment.idRegister}`"
							target="_blank"
						>
							{{ comment.nickName }}
						</router-link>
						<span class="comment__text__date">
							| &nbsp;&nbsp;{{ comment.createDate }}
						</span>
						<button
							@click="
								toggleDisplay(
									comment.idPouchComment,
									comment.isDisplay
								)
							"
							class="comment__text__display-toggle"
							:class="{
								'comment__text__display-toggle--active':
									comment.isDisplay,
								'comment__text__display-toggle--inactive':
									!comment.isDisplay,
							}"
						>
							{{ comment.isDisplay ? '노출삭제' : '노출승인' }}
						</button>
					</p>
					<p class="comment__text__content">
						{{ comment.pouchComment }}
					</p>
				</div>
			</div>
		</div>
		<pagination-box
			class="pagination-box"
			:totalItem="getPageData.total"
			:offset="getPageData.offset"
			:limit="getPageData.limit"
			:pageLengPerOne="pagePerGroup"
			@to="onPageChange"
		/>
	</section>
</template>
<script>
	import util from '@/util';
	import moment from 'moment';
	import PaginationBox from '@/components/PaginationBox';
	import SelectBoxV2 from '@/components/SelectBoxV2';

	export default {
		name: 'CastCommentedUser',
		components: {
			PaginationBox,
			SelectBoxV2,
		},
		props: {
			params: {
				type: Object,
				default: () => {
					{
					}
				},
			},
		},
		data() {
			return {
				comments: [],
				total: 0,
				active: 0,
				inactive: 0,
				limit: 10,
				offset: 0,
				pagePerGroup: 10,
				limitOption: [
					{ label: '10개씩 보기', value: 10 },
					{ label: '20개씩 보기', value: 20 },
					{ label: '30개씩 보기', value: 30 },
					{ label: '40개씩 보기', value: 40 },
					{ label: '50개씩 보기', value: 50 },
				],
			};
		},
		computed: {
			getPageData() {
				return {
					total: this.total,
					offset: this.offset,
					limit: this.limit,
				};
			},
		},
		async mounted() {
			await this.getStatus();
			await this.getComments();
		},
		methods: {
			getComments() {
				return this.$axiosNoah
					.get(`/pouch/${this.params.castId}/comment`, {
						params: {
							limit: this.limit,
							offset: this.offset,
						},
					})
					.then(({ data }) => {
						this.comments = data.pouchCommentList.map(comment => {
							comment.createDate = moment(
								comment.createDate,
								'YYYYMMDDHHmmss'
							).format('YYYY-MM-DD HH:mm');
							comment.profileImage =
								comment.fileDir && comment.fileSaveName
									? `${this.$store.state.env.IMAGE_STORAGE_PATH}${comment.fileDir}/${comment.fileSaveName}`
									: '/static/img-profile-default.png';

							return comment;
						});
					})
					.catch(err => {
						console.error(err);
					});
			},
			getStatus() {
				return this.$axiosNoah
					.get(`/pouch/${this.params.castId}/comment/status`)
					.then(({ data }) => {
						this.total = data.total;
						this.active = data.active;
						this.inactive = data.inactive;
					})
					.catch(err => {
						console.error(err);
					});
			},
			toggleDisplay(id, currentStatus) {
				this.$axiosNoah
					.post(`/pouch/comment/${id}`, {
						isDisplay: !currentStatus,
					})
					.then(() => {
						const target = this.comments.find(
							comment => comment.idPouchComment === id
						);
						target.isDisplay = !target.isDisplay;
						this.getStatus();
					})
					.catch(err => {
						console.error(err);
					});
			},
			onPageChange(event) {
				this.offset = event.offset;
				this.getComments();
			},
			async getExcelFile() {
				const { data, config } = await this.$axiosNoah.get(
					`/pouch/${this.params.castId}/comment/export`
				);
				const rows = data.map(item => [
					moment(item.createDate, 'YYYYMMDDHHmmss').format(
						'YYYY-MM-DD HH:mm'
					),
					item.idRegister,
					item.nickName,
					item.pouchComment,
					item.isDisplay ? '노출' : '비노출',
				]);
				const title = `글로우픽_캐스트 댓글 리스트 (${this.params.castTitle})_${Date.now()}`;
				util.getCsv(
					[rows],
					[title],
					[['등록일시', '회원번호', '닉네임', '내용', '노출상태']],
					title,
					config.url
				);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.commented__top {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 1em 0 2em;
		font-size: 1.2em;
	}

	.commented__excel-download {
		vertical-align: middle;
	}

	.comment {
		display: flex;
		justify-content: flex-start;
		margin-bottom: 2em;
		padding-bottom: 2em;
		border-bottom: 1px solid #ccc;

		&:last-child {
			margin-bottom: 0;
			border-bottom: 0;
		}
	}

	.comment__image {
		width: 80px;
		height: 80px;
		border-radius: 50%;
		padding: 0.5em;
		border: 1px solid #ccc;
	}

	.comment__text {
		padding-left: 2em;
	}

	.comment__text__name {
		display: inline-block;
		width: 6em;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin-right: 1em;
		font-size: 1.5em;
		font-weight: bold;

		&:hover {
			color: $btn-blue;
			text-decoration: underline;
		}
	}

	.comment__text__date {
		margin-right: 1em;
	}

	.comment__text__display-toggle {
		padding: 0.5em;
		border: 1px solid #c0c0c0;
		border-radius: 5px;
		vertical-align: middle;
		font-weight: bold;
		background: #fff;
	}

	.comment__text__display-toggle--active {
		color: $btn-blue;

		&:hover {
			color: $red;
			border-color: $red;
		}
	}

	.comment__text__display-toggle--inactive {
		color: $red;
		border-color: $red;

		&:hover {
			color: $btn-blue;
			border-color: $btn-blue;
		}
	}

	.comment__text__content {
		min-height: 3em;
		margin-top: 1em;
		padding: 0.5em 0 0 1em;
		font-size: 1.1em;
		border-left: 5px solid #c0c0c0;
	}
</style>
